// extracted by mini-css-extract-plugin
export default {"main":"Loginmouseover_main__6-BkY","dynamic":"Loginmouseover_dynamic__v4ND3"};